<app-breadcrumb
	[title]="t('المدفوعات المخصصة (PayPlus)', 'Custom payments (PayPlus)', 'תשלומים מותאמים (PayPlus)')"
	[items]="[t('لوحة التحكم', 'Dashboard', 'לוח בקרה')]"
	[active_item]="t('المدفوعات المخصصة', 'Custom payments', 'תשלומים מותאמים')"
></app-breadcrumb>

<div class="container-fluid basic_table">
	<div class="card mb-3">
		<div class="card-header d-flex justify-content-between flex-wrap gap-2">
			<h5 class="mb-0">
				{{ t('المدفوعات المخصصة (PayPlus)', 'Custom payments (PayPlus)', 'תשלומים מותאמים (PayPlus)') }}
			</h5>
			<div class="d-flex gap-2">
				<button class="btn btn-dark" type="button" (click)="openCreateModal(createCustomPaymentModal)">
					<i class="fa fa-plus-circle mx-1"></i>
					{{ t('إنشاء رابط دفع', 'Create payment link', 'יצירת קישור תשלום') }}
				</button>
				<button class="btn btn-outline-secondary" type="button" (click)="backToPlans()">
					<i class="fa fa-arrow-left mx-1"></i>
					{{ t('العودة للخطط', 'Back to Plans', 'חזרה לתוכניות') }}
				</button>
				<button class="btn btn-outline-warning" type="button" (click)="ensureMerchantsAndLoadList()">
					<i class="fa fa-refresh mx-1"></i>
					{{ t('تحديث', 'Refresh', 'רענון') }}
				</button>
			</div>
		</div>

		<div class="card-body" *ngIf="lastPaymentUrl">
			<div class="payment-link-box">
				<label class="form-label mb-1">
					{{ t('آخر رابط دفع تم إنشاؤه', 'Last generated payment link', 'קישור התשלום האחרון שנוצר') }}
				</label>
				<div class="input-group">
					<input class="form-control" [value]="lastPaymentUrl" readonly />
					<button class="btn btn-outline-primary" type="button" (click)="copyLastPaymentLink()">
						<i class="fa fa-copy mx-1"></i>{{ t('نسخ الرابط', 'Copy Link', 'העתק קישור') }}
					</button>
					<a class="btn btn-outline-dark" [href]="lastPaymentUrl" target="_blank" rel="noopener noreferrer">
						<i class="fa fa-external-link mx-1"></i>{{ t('فتح الرابط', 'Open Link', 'פתח קישור') }}
					</a>
				</div>
			</div>
		</div>
	</div>

	<div class="card mb-3">
		<div class="card-body">
			<div class="row g-3 mb-3">
				<div class="col-md-4">
					<label class="form-label">{{ t('تصفية حسب التاجر', 'Filter by merchant', 'סינון לפי סוחר') }}</label>
					<ng-select
						[(ngModel)]="cpFilterMerchantId"
						[ngModelOptions]="{ standalone: true }"
						[items]="cpMerchants"
						bindLabel="display_label"
						bindValue="merchant_id"
						[clearable]="true"
						[placeholder]="t('كل التجار', 'All merchants', 'כל הסוחרים')"
					>
					</ng-select>
				</div>
				<div class="col-md-4">
					<label class="form-label">{{ t('الحالة', 'Status', 'סטטוס') }}</label>
					<select class="form-select" [(ngModel)]="cpFilterStatus" [ngModelOptions]="{ standalone: true }">
						<option value="">{{ t('الكل', 'All', 'הכל') }}</option>
						<option value="pending">{{ customPaymentStatusLabel('pending') }}</option>
						<option value="paid">{{ customPaymentStatusLabel('paid') }}</option>
						<option value="failed">{{ customPaymentStatusLabel('failed') }}</option>
					</select>
				</div>
				<div class="col-md-4 d-flex align-items-end gap-2">
					<button type="button" class="btn btn-outline-primary flex-grow-1" (click)="applyCustomPaymentFilters()">
						<i class="fa fa-filter mx-1"></i>
						{{ t('تطبيق', 'Apply', 'החל') }}
					</button>
					<button type="button" class="btn btn-outline-warning" (click)="loadCustomPaymentsList()">
						<i class="fa fa-refresh"></i>
					</button>
				</div>
			</div>

			<div class="table-responsive">
				<table class="table table-hover table-bordered text-center align-middle">
					<thead class="table-light">
						<tr>
							<th>#</th>
							<th>{{ t('التاجر', 'Merchant', 'סוחר') }}</th>
							<th>{{ t('العنوان', 'Title', 'כותרת') }}</th>
							<th>{{ t('المبلغ', 'Amount', 'סכום') }}</th>
							<th>{{ t('الحالة', 'Status', 'סטטוס') }}</th>
							<th>{{ t('انتهاء الرابط', 'Link expires', 'תוקף הקישור') }}</th>
							<th>{{ t('دفع في', 'Paid at', 'שולם ב') }}</th>
							<th>{{ t('الإجراءات', 'Actions', 'פעולות') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of cpRows">
							<td>{{ row.id }}</td>
							<td>{{ getCpMerchantName(row.merchant_id) }}</td>
							<td class="text-start">{{ row.title }}</td>
							<td>{{ row.amount }}</td>
							<td>
								<span class="badge" [ngClass]="customPaymentStatusClass(row.status)">
									{{ customPaymentStatusLabel(row.status) }}
								</span>
								<span *ngIf="row.is_link_expired" class="badge bg-secondary ms-1">
									{{ t('الرابط منتهٍ', 'Link expired', 'הקישור פג') }}
								</span>
							</td>
							<td>{{ row.link_expiry_at ? (row.link_expiry_at | date : 'dd/MM/yyyy HH:mm') : '—' }}</td>
							<td>{{ row.paid_at ? (row.paid_at | date : 'dd/MM/yyyy HH:mm') : '—' }}</td>
							<td>
								<button
									*ngIf="row.payment_url"
									type="button"
									class="btn btn-sm btn-outline-primary me-1"
									(click)="copyCustomPaymentUrl(row.payment_url)"
									title="{{ t('نسخ رابط الدفع', 'Copy payment link', 'העתק קישור תשלום') }}"
								>
									<i class="fa fa-copy"></i>
								</button>
								<a
									*ngIf="row.payment_url"
									class="btn btn-sm btn-outline-dark me-1"
									[href]="row.payment_url"
									target="_blank"
									rel="noopener noreferrer"
								>
									<i class="fa fa-external-link"></i>
								</a>
								<button
									*ngIf="row.status === 'pending'"
									type="button"
									class="btn btn-sm btn-outline-danger"
									(click)="deleteCustomPayment(row)"
								>
									<i class="fa fa-trash"></i>
								</button>
							</td>
						</tr>
						<tr *ngIf="cpRows.length === 0">
							<td colspan="8" class="text-muted py-4">
								{{ t('لا توجد مدفوعات مخصصة', 'No custom payments yet', 'אין תשלומים מותאמים') }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="d-flex justify-content-between align-items-center flex-wrap gap-2" *ngIf="cpTotal > 0">
				<span class="text-muted small">
					{{ t('الصفحة', 'Page', 'עמוד') }} {{ cpPage }} / {{ cpTotalPages }} — {{ cpTotal }}
					{{ t('سجل', 'records', 'רשומות') }}
				</span>
				<div class="btn-group">
					<button
						type="button"
						class="btn btn-outline-secondary btn-sm"
						[disabled]="cpPage <= 1"
						(click)="setCustomPaymentPage(cpPage - 1)"
					>
						{{ t('السابق', 'Previous', 'הקודם') }}
					</button>
					<button
						type="button"
						class="btn btn-outline-secondary btn-sm"
						[disabled]="cpPage >= cpTotalPages"
						(click)="setCustomPaymentPage(cpPage + 1)"
					>
						{{ t('التالي', 'Next', 'הבא') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #createCustomPaymentModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">
			{{ t('إنشاء رابط دفع', 'Create payment link', 'יצירת קישור תשלום') }}
		</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>

	<div class="modal-body">
		<form [formGroup]="customPaymentForm" class="row g-3">
			<div class="col-md-6">
				<label class="form-label">{{ t('التاجر', 'Merchant', 'סוחר') }} *</label>
				<ng-select
					[items]="cpMerchants"
					bindLabel="display_label"
					bindValue="merchant_id"
					formControlName="merchant_id"
					[placeholder]="t('اختر التاجر', 'Select merchant', 'בחר סוחר')"
					[clearable]="false"
				>
				</ng-select>
				<div class="invalid-feedback d-block" *ngIf="isInvalidCp('merchant_id')">
					{{ t('اختر تاجرًا', 'Please select a merchant', 'אנא בחר סוחר') }}
				</div>
			</div>
			<div class="col-md-6">
				<label class="form-label">{{ t('العنوان', 'Title', 'כותרת') }} *</label>
				<input type="text" class="form-control" formControlName="title" maxlength="255" />
				<div class="invalid-feedback d-block" *ngIf="isInvalidCp('title')">
					{{ t('أدخل عنوانًا صالحًا', 'Enter a valid title', 'הזן כותרת תקינה') }}
				</div>
			</div>
			<div class="col-12">
				<label class="form-label">{{ t('الوصف', 'Description', 'תיאור') }}</label>
				<textarea class="form-control" rows="2" formControlName="description" maxlength="1000"></textarea>
			</div>
			<div class="col-md-4">
				<label class="form-label">{{ t('المبلغ (₪)', 'Amount (ILS)', 'סכום (₪)') }} *</label>
				<input type="number" class="form-control" min="1" step="0.01" formControlName="amount" />
				<div class="invalid-feedback d-block" *ngIf="isInvalidCp('amount')">
					{{ t('المبلغ يجب أن يكون ≥ 1', 'Amount must be ≥ 1', 'הסכום חייב להיות ≥ 1') }}
				</div>
			</div>
			<div class="col-md-4">
				<label class="form-label">{{ t('لغة صفحة الدفع', 'Checkout language', 'שפת דף התשלום') }}</label>
				<select class="form-select" formControlName="language">
					<option value="ar">{{ t('العربية', 'Arabic', 'ערבית') }}</option>
					<option value="he">{{ t('العبرية', 'Hebrew', 'עברית') }}</option>
					<option value="en">{{ t('الإنجليزية', 'English', 'אנגלית') }}</option>
				</select>
			</div>
		</form>
	</div>

	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-dark"
			[disabled]="isCustomPaymentSubmitting"
			(click)="submitCustomPayment()"
		>
			<i class="fa fa-link mx-1"></i>
			{{ t('إنشاء الرابط', 'Create link', 'צור קישור') }}
		</button>
		<button type="button" class="btn btn-outline-danger" (click)="modal.dismiss()">
			{{ t('إلغاء', 'Cancel', 'ביטול') }}
		</button>
	</div>
</ng-template>
